import React from 'react';
import { RoundActionButton } from '../ActionButton';

var A4_RoundActionButton = function A4_RoundActionButton(props) {
  return /*#__PURE__*/React.createElement(RoundActionButton, props);
};

export { A4_RoundActionButton };